import React, { useEffect, useState } from 'react'
import { contentService } from '../../services/content.service'
import { SplitScreenContext } from '../../layouts/SplitScreenLayout'

export const privacyPolicyContext: SplitScreenContext = {
  id: 'privacy-policy',
  title: 'Privacy <em>Policy</em>',
  message: '',
  contentSide: 'left',
  logoSrc: '/images/landing-v2/logo.png',
  variant: 'v2',
}

const PrivacyPolicyPage = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState<string>('')

  useEffect(() => {
    const handleLoad = async () => {
      try {
        const content = await contentService.getPrivacyPolicy()
        setPrivacyPolicy(content)
      } catch (error) {
        console.error('Retrieving privacy policy failed:', error)
      } finally {
      }
    }
    handleLoad()
  }, [])

  return <div className="legal-content" dangerouslySetInnerHTML={{ __html: privacyPolicy }} />
}

export default PrivacyPolicyPage
